import request from "../utils/request";

export async function GetAllDiscountReason() {
    return request.get("DiscountReason/GetAll");
  }

  export async function Add(discountReason){
    return request.post("DiscountReason/Add",discountReason);
  }

  export async function Update(blackList){
    return request.post("DiscountReason/Update",blackList);
  }

  export async function Delete(id){
    return request.delete('DiscountReason/Delete?id='+id);
  }